import { DonateBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { DonateBlock } from './DonateBlock';

export const DonateBlockMapping: BlockMapping<DonateBlockData> = {
  invariant: [],
  width: 'FULL',
  Component: DonateBlock,
  AmpComponent: DonateBlock,
};
